module.exports = __webpack_public_path__ + "img/ar_h_x.2c012c0b.svg";